const theme = {
    hljs: {
        display: 'block',
        background: '#22272e',
        padding: '1em',
        color: '#adbac7',
        overflowX: 'auto',
    },

    'hljs-doctag': {
        color: '#f47067',
    },
    'hljs-keyword': {
        color: '#f47067',
    },
    'hljs-template-tag': {
        color: '#f47067',
    },
    'hljs-template-variable': {
        color: '#f47067',
    },
    'hljs-type': {
        color: '#f47067',
    },
    'hljs-variable.language_': {
        color: '#f47067',
    },

    'hljs-title': {
        color: '#dcbdfb',
    },
    'hljs-title.class_': {
        color: '#dcbdfb',
    },
    'hljs-title.class_.inherited__': {
        color: '#dcbdfb',
    },
    'hljs-title.function_': {
        color: '#dcbdfb',
    },

    'hljs-attr': {
        color: '#6cb6ff',
    },
    'hljs-attribute': {
        color: '#6cb6ff',
    },
    'hljs-literal': {
        color: '#6cb6ff',
    },
    'hljs-number': {
        color: '#6cb6ff',
    },
    'hljs-operator': {
        color: '#6cb6ff',
    },
    'hljs-selector-attr': {
        color: '#6cb6ff',
    },
    'hljs-selector-class': {
        color: '#6cb6ff',
    },
    'hljs-selector-id': {
        color: '#6cb6ff',
    },
    'hljs-variable': {
        color: '#6cb6ff',
    },
    'hljs-meta': {
        color: '#96d0ff',
    },
    'hljs-string': {
        color: '#96d0ff',
    },
    'hljs-regexp': {
        color: '#96d0ff',
    },

    'hljs-built_in': {
        color: '#f69d50',
    },
    'hljs-symbol': {
        color: '#f69d50',
    },

    'hljs-code': {
        color: '#768390',
    },
    'hljs-quote': {
        color: '#768390',
    },
    'hljs-selector-pseudo': {
        color: '#768390',
    },
    'hljs-selector-tag': {
        color: '#768390',
    },

    'hljs-subst': {
        color: '#adbac7',
    },

    'hljs-section': {
        color: '#316dca',
        fontWeight: '700',
    },

    'hljs-bullet': {
        color: '#eac55f',
    },

    'hljs-emphasis': {
        color: '#adbac7',
        fontStyle: 'italic',
    },

    'hljs-strong': {
        color: '#adbac7',
        fontWeight: '700',
    },

    'hljs-addition': {
        color: '#b4f1b4',
        backgroundColor: '#1b4721',
    },

    'hljs-deletion': {
        color: '#ffd8d3',
        backgroundColor: '#78191b',
    },
};

export default theme;
